import { inject, Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, GuardResult, MaybeAsync, Router, RouterStateSnapshot } from "@angular/router";
import { AuthService } from "@core/services/auth.service";
import { ClientStateService } from "@shared/services/client-state.service";
import { tap } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class AuthGuard implements CanActivate {
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);
  private readonly clientStateService = inject(ClientStateService);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): MaybeAsync<GuardResult> {
    if (this.authService.isAuthenticated()) {
      return this.clientStateService.initCustomerState().pipe(
        tap((isCustomerInitialized) => {
          if (!isCustomerInitialized) {
            this.authService.logout();
          }
        }),
      );
    }

    return this.router.createUrlTree(["/login"], { queryParams: { returnUrl: state.url } });
  }
}
